var map = {
	"./icon-act.svg": "cd88",
	"./icon-arrow-background-btn-down.svg": "8aa5",
	"./icon-arrow-background-btn-left.svg": "13c3",
	"./icon-arrow-background-btn-right.svg": "cd2e",
	"./icon-arrow-background-btn-up.svg": "1fb6",
	"./icon-arrow-background-btn.svg": "c036",
	"./icon-arrow-flat.svg": "02f6",
	"./icon-arrow-menu.svg": "ef30",
	"./icon-arrow-up.svg": "cdec",
	"./icon-arrow.svg": "9f84",
	"./icon-close.svg": "3c76",
	"./icon-conference.svg": "a803",
	"./icon-email.svg": "2ed8",
	"./icon-excel.svg": "de88",
	"./icon-info.svg": "1531",
	"./icon-instagram.svg": "3b08",
	"./icon-logout.svg": "51a8",
	"./icon-odnoklassniki.svg": "e82b",
	"./icon-pencil.svg": "e235",
	"./icon-plus.svg": "77ea",
	"./icon-powerpoint.svg": "7eda",
	"./icon-search.svg": "e854",
	"./icon-seminar.svg": "4753",
	"./icon-tel.svg": "3e09",
	"./icon-telegram.svg": "7a61",
	"./icon-tick.svg": "c70d",
	"./icon-trash.svg": "2d7f",
	"./icon-vk.svg": "3699",
	"./icon-webinar.svg": "8e27",
	"./icon-whatsapp.svg": "3d23",
	"./icon-word.svg": "34ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";